import * as React from 'react'
import GridItem from '../../../grid/GridItem'
import GridContainer from '../../../grid/GridContainer'
import CustomTabs from '../../../tab/CustomTabs'
import CreateTenant from './page/CreateTenant'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import PeopleIcon from '@material-ui/icons/People'
import ApartmentIcon from '@material-ui/icons/Apartment'
import ExTenantPage from './page/ExTenantPage'
import FutureTenantTable from '../table/FutureTenantTable'
// import TenantAdditional from './page/TenantAdditional'
// import EqualizerIcon from '@material-ui/icons/Equalizer'
import CurrentTenantTable from '../table/CurrentTenantTable'

export default function AdminTenantsTab() {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CustomTabs
          headerColor="primary"
          tabs={[
            {
              tabName: 'Aktuelle Bewohner',
              tabIcon: PeopleIcon,
              tabContent: <CurrentTenantTable />,
            },
            {
              tabName: 'Neuer Bewohner',
              tabIcon: PersonAddIcon,
              tabContent: <CreateTenant />,
            },
            {
              tabName: 'Einzügler',
              tabIcon: PeopleIcon,
              tabContent: <FutureTenantTable />,
            },
            // {
            //   tabName: 'Übersicht',
            //   tabIcon: EqualizerIcon,
            //   tabContent: <TenantAdditional />,
            // },
            {
              tabName: 'Ehemalige Bewohner',
              tabIcon: ApartmentIcon,
              tabContent: <ExTenantPage />,
            },
          ]}
        />
      </GridItem>
    </GridContainer>
  )
}
